var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReschedule2 = function SvgReschedule2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.81 10.446V8.133H2.977v9.166a.833.833 0 0 0 .833.834h6.222",
    stroke: "#6B7280",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.977 4.384a.833.833 0 0 1 .833-.833h14.167a.833.833 0 0 1 .833.833v3.75H2.977v-3.75ZM7.559 2.3v3.334M14.227 2.3v3.334",
    stroke: "#6B7280",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.695 17.442a3.333 3.333 0 1 1-1.22-4.553c.376.218 1.217.772 1.217.772",
    stroke: "#6B7280",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.643 12.392.383 1.43-1.431.384M15.808 14.405v1.607l1.134 1.134",
    stroke: "#6B7280",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReschedule2;